const updateFormControls = ({
  variant,
  variantsData,
  optionNames,
  selectedOptions,
  atcButton,
  quantitySelector
}) => {
  if (!atcButton) return;

  const allOptionsSelected = variantsData.length === 1 || optionNames.every(name => selectedOptions[name]);
  const quantityControls = quantitySelector?.querySelectorAll('button, input') || [];

  if (variant && variant.available && allOptionsSelected) {
    quantityControls.forEach(control => control.removeAttribute('disabled'));
    atcButton.disabled = false;
  } else {
    quantityControls.forEach(control => control.setAttribute('disabled', true));
    atcButton.disabled = true;
  }
};

export default updateFormControls;
